var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loader text-center py-5"},[_c('div',{staticClass:"spinner-border",style:(_vm.accentColor ? `color:${_vm.accentColor}` : ''),attrs:{"role":"status"}}),_c('p',{staticClass:"mt-2 text-muted small"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }